import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ImageComponent from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { getValueOrDefaultAlternativeObject } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
import { useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { selctedAddressCheck } from '../SearchStoreUtilities/SearchStoreUtils';
const { Error } = IMAGE_PATH;
export const LocationWarningFormComp = props => {
  const { show, address, suggestedAddress, onRetryClickHandler, onUseThisAddressHandler, changeAddressErrorMsgStyle } = props;
  const { LOCATION_WARNING_MESSAGE, RETRY_BTN_TEXT, USE_THIS_ADDRESS_TEXT } = TRANSLATE_MAPPING_KEY;
  const getPwaStorageData = useAppSelector(getPWAstorage);
  return show ? (
    <div className='err-container'>
      <div data-testid='alert-locationid' className='alert-location-popup'>
       {!changeAddressErrorMsgStyle && <ImageComponent srcFile={Error} className='location-alert-icon' />}
        <div className={changeAddressErrorMsgStyle ? 'location-error-message location-error-message-change-style': 'location-error-message'}>{translateWithI18Next(LOCATION_WARNING_MESSAGE)}</div>
        <div className='location-error-address'>
          {getValueOrDefaultAlternativeObject(suggestedAddress?.[0]?.description, selctedAddressCheck(getPwaStorageData)??address)};
        </div>
        <div className='location-error-button-section'>
          <ButtonComp
            className='button whiteButton blackBorder location-warning-button mr'
            onClick={onRetryClickHandler}
            data-testid='location-retry-btn'
          >
            {translateWithI18Next(RETRY_BTN_TEXT)}
          </ButtonComp>
          <ButtonComp
            className='button whiteButton blackBorder location-warning-button ml'
            data-testid='use-this-address'
            onClick={onUseThisAddressHandler}
          >
            {translateWithI18Next(USE_THIS_ADDRESS_TEXT)}
          </ButtonComp>
        </div>
      </div>
    </div>
  ) : null;
};

export const LocationWarningForm = React.memo(LocationWarningFormComp);
